import { Box, Paper, Typography } from '@mui/material';
import { Link as RouterLink, useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useFormik } from 'formik';
import { CustomInput } from '../../../../components/CustomInput';
import { UploadFiles } from '../../../../components/UploadFiles';
import { CustomInputTextArea } from '../../../../components/CustomInputTextArea';
import { CustomButton } from '../../../../components/CustomButton';
import { ROUTES } from '../../../../constants/routes';
import { validationSchema } from './utils';
import { convertToRaw, EditorState } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import { postPackages, uploadPackageImage } from '../../../../store/bonuses/actions';
import { useState } from 'react';
import { PromotionDescriptionEditor } from '../../components/PromotionDescriptionEditor';
import { PACKAGE_NAME_MAX_LENGTH } from '../../constants';

export const CreatePackage = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [error, setError] = useState();

  const { values, touched, errors, handleSubmit, handleChange, setFieldValue } = useFormik({
    initialValues: {
      code: '',
      promotion_type: 'partner_promotion',
      name: {
        en: '',
        ru: '',
        kz: ''
      },
      description: {
        en: EditorState.createEmpty(),
        ru: EditorState.createEmpty(),
        kz: EditorState.createEmpty()
      },
      short_description: {
        en: '',
        ru: '',
        kz: ''
      },
      banner: {
        en: undefined,
        ru: undefined,
        kz: undefined
      }
    },
    validationSchema: validationSchema(),
    validateOnChange: true,
    onSubmit: async (values) => {
      try {
        await dispatch(
          postPackages({
            ...values,
            description: {
              en: draftToHtml(convertToRaw(values.description.en.getCurrentContent())),
              ru: draftToHtml(convertToRaw(values.description.ru.getCurrentContent())),
              kz: draftToHtml(convertToRaw(values.description.kz.getCurrentContent()))
            }
          })
        );

        history.push(ROUTES.BONUSES);
      } catch (error) {
        setError(error.message);
      }
    }
  });

  const getObjectValueFromString = (object, path) => {
    const pathArr = path.split('.');
    if (pathArr.length === 1) {
      return object[path];
    }

    let value = object;

    for (const path of pathArr) {
      if (!value[path]) {
        return value[path];
      }
      value = value[path];
    }

    return value;
  };

  const registerInput = (name) => ({
    name,
    value: getObjectValueFromString(values, name),
    error: getObjectValueFromString(touched, name) && getObjectValueFromString(errors, name)
  });

  const handleUploadFiles = async (file, field) => {
    const formData = new FormData();
    formData.append('uploaded_file', file);

    const data = await dispatch(uploadPackageImage(formData));

    setFieldValue(`banner.${field}`, data.path);
  };

  return (
    <Box>
      <Typography
        mb="24px"
        variant="h1"
        sx={{ color: 'text.primary' }}
        component="h1"
        data-testid="Title">
        Создание пакета
      </Typography>

      <Paper sx={{ padding: '24px', marginTop: '24px' }}>
        <form onSubmit={handleSubmit}>
          <Box sx={{ display: 'grid', gap: '34px' }}>
            <Box sx={{ display: 'grid', rowGap: '16px' }}>
              <CustomInput {...registerInput('code')} onChange={handleChange} placeholder="Код" />
            </Box>

            <Box sx={{ display: 'grid', rowGap: '16px' }}>
              <UploadFiles
                title="Превью en"
                name="banner.en"
                setFieldValue={setFieldValue}
                image
                uploadFetch={(file) => handleUploadFiles(file, 'en')}
              />
              <Box color="error.main" fontSize="1rem" textAlign="center">
                {errors?.banner?.en}
              </Box>
            </Box>
            <Box sx={{ display: 'grid', rowGap: '16px' }}>
              <UploadFiles
                title="Превью ru"
                name="banner.ru"
                setFieldValue={setFieldValue}
                image
                uploadFetch={(file) => handleUploadFiles(file, 'ru')}
              />
              <Box color="error.main" fontSize="1rem" textAlign="center">
                {errors?.banner?.ru}
              </Box>
            </Box>
            <Box sx={{ display: 'grid', rowGap: '16px' }}>
              <UploadFiles
                title="Превью kz"
                name="banner.kz"
                setFieldValue={setFieldValue}
                image
                uploadFetch={(file) => handleUploadFiles(file, 'kz')}
              />
              <Box color="error.main" fontSize="1rem" textAlign="center">
                {errors?.banner?.kz}
              </Box>
            </Box>

            <Box sx={{ display: 'grid', rowGap: '16px' }}>
              <CustomInput
                {...registerInput('name.en')}
                onChange={handleChange}
                placeholder="Наименование пакета en"
                inputProps={{ maxLength: PACKAGE_NAME_MAX_LENGTH }}
              />
            </Box>
            <Box sx={{ display: 'grid', rowGap: '16px' }}>
              <CustomInput
                {...registerInput('name.ru')}
                onChange={handleChange}
                placeholder="Наименование пакета ru"
                inputProps={{ maxLength: PACKAGE_NAME_MAX_LENGTH }}
              />
            </Box>
            <Box sx={{ display: 'grid', rowGap: '16px' }}>
              <CustomInput
                {...registerInput('name.kz')}
                onChange={handleChange}
                placeholder="Наименование пакета kz"
                inputProps={{ maxLength: PACKAGE_NAME_MAX_LENGTH }}
              />
            </Box>

            <Box sx={{ display: 'grid', rowGap: '16px' }}>
              <CustomInputTextArea
                {...registerInput('short_description.en')}
                onChange={handleChange}
                placeholder="Краткое описание en"
                style={{ height: 120, width: '100%' }}
                onPaste={(e) => e.clipboardData.getData('text').length > 1000 && e.preventDefault()}
              />
            </Box>
            <Box sx={{ display: 'grid', rowGap: '16px' }}>
              <CustomInputTextArea
                {...registerInput('short_description.ru')}
                onChange={handleChange}
                placeholder="Краткое описание ru"
                style={{ height: 120, width: '100%' }}
                onPaste={(e) => e.clipboardData.getData('text').length > 1000 && e.preventDefault()}
              />
            </Box>
            <Box sx={{ display: 'grid', rowGap: '16px' }}>
              <CustomInputTextArea
                {...registerInput('short_description.kz')}
                onChange={handleChange}
                placeholder="Краткое описание kz"
                style={{ height: 120, width: '100%' }}
                onPaste={(e) => e.clipboardData.getData('text').length > 1000 && e.preventDefault()}
              />
            </Box>

            <PromotionDescriptionEditor
              values={values.description}
              errors={errors?.description}
              onChange={(language, editorState) =>
                setFieldValue(`description.${language}`, editorState)
              }
            />
          </Box>

          <Box color="error.main" fontSize="1rem" textAlign="center">
            {error}
          </Box>

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginTop: '24px'
            }}>
            <Box>
              <CustomButton
                size="large"
                color="secondary"
                variant="contained"
                component={RouterLink}
                to={ROUTES.PARTNERS}>
                Отмена
              </CustomButton>

              <CustomButton
                type="submit"
                sx={{ marginLeft: '16px', width: '146px' }}
                size="large"
                variant="contained">
                Сохранить
              </CustomButton>
            </Box>
          </Box>
        </form>
      </Paper>
    </Box>
  );
};
